import { Lightbulb, Shield, Users, Award, Heart } from 'lucide-react';

export const values = [
  {
    icon: Lightbulb,
    title: "Innovation",
    description: "Continuously improving our AI solutions and big data platforms to deliver the most advanced services."
  },
  {
    icon: Shield,
    title: "Integrity",
    description: "We maintain transparency and ethical standards in everything we do, ensuring trust with our clients."
  },
  {
    icon: Users,
    title: "Collaboration",
    description: "Our team works closely with clients, providing tailored data analytics solutions for better results."
  },
  {
    icon: Award,
    title: "Excellence",
    description: "We are committed to delivering high-quality AI-powered business analytics solutions that exceed expectations."
  },
  {
    icon: Heart,
    title: "Customer-Centric",
    description: "Putting the needs of our clients at the forefront, we ensure that every solution we provide aligns with their goals."
  }
];
